// 手机买票——微信，主流程
const wxMainRoutes = Array.from({ length: 22 }, (_, i) => ({
  path: `aircraft/wx/index${i + 1}`,
  name: `aircraftWxIndex${i + 1}`,
  component: () => import(`@/views/traffic/aircraft/wx/index${i + 1}.vue`)
}))

// 手机买票——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 20 }, (_, i) => ({
  path: `aircraft/zfb/index${i + 1}`,
  name: `aircraftZfbIndex${i + 1}`,
  component: () => import(`@/views/traffic/aircraft/zfb/index${i + 1}.vue`),
}));


// 手机买票——铁路12306，主流程
const tlMainRoutes = Array.from({ length:20 }, (_, i) => ({
  path: `aircraft/tl/index${i + 1}`,
  name: `aircraftTlIndex${i + 1}`,
  component: () => import(`@/views/traffic/aircraft/tl/index${i + 1}.vue`),
}));


export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机买票——微信，开始
    ...wxMainRoutes,

    // 手机买票——支付宝，主流程
    ...zfbMainRoutes,

    // 手机买票——铁路12306，主流程
    ...tlMainRoutes,
  ],
};
